<template>
  <section class="CostAllocationView">
    <div class="row pt-6 pb-4">
      <div class="col-12 font-l">
        {{ $t('CostAllocation.description') }}
      </div>
    </div>
    <div
      v-if="businessProfile.cost_allocations.length"
      class="row"
    >
      <div class="col-md-6">
        <MuiMultiSelect
          v-for="(item, property) in allocations"
          :key="property"
          v-model="formModel[property]"
          :options="item.data"
          :name="property"
          :label="property"
          :disabled="!item.STATUS.LOADED"
          object-label="code"
          full-width
          object-value="uuid"
          size="m"
          class="mb-3"
        />
        <MuiButtonFlat
          :is-loading="STATUS.LOADING"
          :disabled="isSaveButtonDisabled"
          size="m"
          @click.native="saveCostAllocations"
        >
          {{ $t('CostAllocation.saveButton') }}
        </MuiButtonFlat>
        <MuiCardAlert
          v-if="STATUS.LOADED || STATUS.ERROR"
          :type="STATUS.ERROR ? 'danger' : 'success'"
          full-width
          class="pt-3"
        >
          {{ STATUS.ERROR ? $t('CostAllocation.errorMessage') : $t('CostAllocation.successMessage') }}
        </MuiCardAlert>
      </div>
    </div>
    <div v-else>
      {{ $t('CostAllocation.notAssigned') }}
    </div>
  </section>
</template>
<script>
import {
  mapState, mapGetters, mapActions, mapMutations,
} from 'vuex';
import { MuiMultiSelect, MuiButtonFlat, MuiCardAlert } from '@ubeeqo/motion-ui';
import MAIN_VIEW_MODEL from '@/views/MAIN_VIEW_MODEL';
import VIEW_MODEL from '@/store/modules/VIEW_MODEL';

export default {
  name: 'CostAllocationView',
  components: {
    MuiMultiSelect,
    MuiButtonFlat,
    MuiCardAlert,
  },
  data() {
    return {
      formModel: {},
    };
  },
  computed: {
    ...mapState(MAIN_VIEW_MODEL.userAccount, {
      userUuid: state => state.data.uuid,
    }),
    ...mapState(VIEW_MODEL.profiles.business.costAllocation, {
      allocations: state => state.data,
      STATUS: state => state.STATUS,
    }),
    ...mapGetters(MAIN_VIEW_MODEL.userAccount, ['businessProfile']),
    selectedCostAllocationUuids() {
      const uuids = [];
      Object.keys(this.formModel).forEach((key) => {
        this.formModel[key].forEach((allocation) => {
          uuids.push(allocation.uuid);
        });
      });
      return uuids;
    },
    isSaveButtonDisabled() {
      return Object.keys(this.formModel).some(item => !this.formModel[item].length);
    },
  },
  created() {
    this.businessProfile.cost_allocations.forEach((item) => {
      const allocation = this.getSelectedAllocationObject(item);
      this.$set(this.formModel, item.name, [...allocation]);
      this.getUserCostAllocations({
        costAllocationUuid: item.uuid,
        type: item.name,
      });
    });
  },
  destroyed() {
    this.resetStore();
  },
  methods: {
    ...mapMutations(VIEW_MODEL.profiles.business.costAllocation, ['resetStore']),
    ...mapActions(VIEW_MODEL.profiles.business.costAllocation, ['getUserCostAllocations', 'putUserCostAllocations']),
    getSelectedAllocationObject(item) {
      const allocation = { ...item };
      allocation.children.forEach((item, index) => {
        delete allocation.children[index].level;
        delete allocation.children[index].hasChildren;
      });
      return allocation.children;
    },
    saveCostAllocations() {
      const params = {
        cost_allocation_uuids: this.selectedCostAllocationUuids,
      };
      this.putUserCostAllocations({ businessProfileUuid: this.businessProfile.uuid, params });
    },
  },
};
</script>
